const VARIANTS = {
  pink: "bg-[#FF69B4] text-white",
  gold: "bg-[#FFD700] text-[#4A3728]",
  blue: "bg-[#5B8FB9] text-white",
  teal: "bg-[#40E0D0] text-[#4A3728]",
  purple: "bg-[#9B59B6] text-white",
  orange: "bg-[#FF8C42] text-white",
  green: "bg-[#4CAF50] text-white",
  white: "bg-white text-[#4A3728] border-2 border-[#FFC0CB]",
};

export default function JoyButton({
  children,
  variant = "pink",
  className = "",
  disabled = false,
  full = false,
  onClick,
  type = "button",
  ...rest
}) {
  return (
    <button
      type={type}
      onClick={onClick}
      disabled={disabled}
      className={`joy-press inline-flex items-center justify-center gap-2 rounded-[22px] px-6 font-extrabold ${VARIANTS[variant]} ${full ? "w-full" : ""} ${
        disabled ? "opacity-50 cursor-not-allowed" : "hover:brightness-105"
      } ${className}`}
      style={{ minHeight: 52, boxShadow: "0 6px 0 rgba(0,0,0,0.08), 0 10px 18px rgba(0,0,0,0.08)" }}
      {...rest}
    >
      {children}
    </button>
  );
}
